import * as Yup from "yup";
export const validationSchema = Yup.object().shape({
  comment: Yup.string()
    .trim("لايمكن ان يحوي رفراغات")
    .required("يرجى ادخال السؤال"),
  images: Yup.array().max(5),
});
export const formikProps = {
  validationSchema,
  formik: {
    onChangeValidate: false,
    onBlurValidate: false,
  },
  initialValues: {
    comment: "",
    images: [],
  },
};
